import { delay } from '@/utils/delay';
import { redirectUrl } from '@/utils/app';
import { Autoplay, Pagination } from 'swiper/modules';
import { CarouselConfigModel } from '@/api/normal/model';
import { useVipStore } from '@/store/vip';

export default function useSwiperViewLogic(emit: any) {
  const tenantStore = useTenantStore();// 租户store

  const showIonImg = ref(false);       // 解决ion-img刷新出现白色边框
  const carouselList = computed(() => tenantStore.carouselList);        // 轮播图数据
  const isLoopEnabled = computed(() => carouselList.value.length > 2);  // 是否开启循环(开启循环最少3条元素)

  const router = useRouter();               // 路由对象
  const activityStore = useActivityStore(); // 活动store

  const swiperRef = ref();                      // 轮播图DOM
  const modules = ref([Autoplay, Pagination]);  // 轮播图模块

  /**
   * @description 轮播图点击事件
   * @param item 轮播图数据
   */
  async function swiperHandle(item: CarouselConfigModel[0]) {
    // 外部链接跳转
    if (item.linkType === 'url') {
      redirectUrl(httpCompletion(item.linkValue))
      return;
    }
    // 项目路由跳转
    if (item.linkType === 'activity') {
      // linkValue是数字, 则跳转到活动详情页
      if (checkNumByStr(item.linkValue)) {
        const activityList = await activityStore.getActivityList();
        // 根据id查找linkValue对应活动
        const activity: any = activityList.find(it => it?.id === Number(item.linkValue));
        if (!activity) return              // 找不到匹配的活动 点击没反应
        if (activity?.type === 'Rebate') {
          activityStore.pageType = 2;
          router.push(`/main/promo`);
        } else {
          router.push(`/activity/${activity?.type}/${activity?.id}`);
        }
        return;
      }
      if (item.linkValue === '/Redeem') {
        activityStore.pageType = 4;
        router.push(`/main/promo`);
      } else if (item.linkValue == '/') {
        router.replace('/launch').then(() => {
          location.reload();
        });
      } else {
        // linkValue是路由路径
        let linkValue = item.linkValue
        if (linkValue == '/main/entrar' || linkValue == '/recharge/apply') {
          const bool = await useHandleRecharge()
          if (bool) return
        } else if (linkValue == '/main/withdraw' || linkValue == '/withdraw/apply') {
          const bool = await useHandleWithdraw()
          if (bool) return
        }
        if (linkValue == '/activity/vip') {
          // 如果是vip页面, 则检测是否有权限
          const vipStore = useVipStore()
          await vipStore.getActivityVipType()
          if (!vipStore.activityVipType) return;
        }
        router.push(item.linkValue);
      }
      return;
    }
  }

  // 生命周期: 组件挂载前
  onBeforeMount(async () => {
    await tenantStore.loadCarouselList(); // 获取轮播图数据
    showIonImg.value = true
  })

  // 生命周期: 组件挂载完成
  onMounted(async () => {
    await nextTick();
    emit('loaded')                              // 触发父组件加载完成事件
  })

  /**
   * @description swiper初始化完成
   * @param swiper
   */
  async function onSwiper(swiper: any) {
    await delay(3000);
    swiper.slideTo(1); // 滑动到第一个slide
  };

  return {
    carouselList,
    isLoopEnabled,
    swiperRef,
    modules,
    showIonImg,
    swiperHandle,
    onSwiper
  }
}
